// @ts-nocheck

import { createSelector } from 'reselect';

import { selectKLTmpNotifications } from '../misc';
import { selectKLUserRound } from '../user';

const selectFirstNotification = createSelector([selectKLTmpNotifications], (tmpNotifications) => {
  const first = tmpNotifications[0];

  if (first) {
    const res = { ...first };
    const { data } = res;
    res.data = { ...data, collectibleId: data?.id ?? data?.badgeId };
    delete data?.badgeId;
    return res;
  }

  return null;
});

const selectIsLastNotification = createSelector(
  [selectKLTmpNotifications],
  (tmpNotifications) => tmpNotifications.length === 1,
);

const selectKLNotificationsViewerProps = createSelector(
  [selectFirstNotification, selectIsLastNotification, selectKLUserRound],
  (notification, isLast, currentRound) => ({
    notification,
    isLast,
    currentRound,
  }),
);

export default selectKLNotificationsViewerProps;
